export const clientCode: string="CIBCMMEMBER";